import 'angular:locale/data:en-NL';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en-NL";
